import { config } from "./config";

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${config.hubUrl}${path}`, { ...init, headers: { "Content-Type": "application/json", ...init?.headers } });
  if (!res.ok) throw Object.assign(new Error(`hub ${res.status}`), { status: res.status });
  return (await res.json()) as T;
}

/** Hub HTTP API. An object (not loose functions) so tests can spy on it. */
export const hubApi = {
  async createRoom(): Promise<string> {
    return (await call<{ code: string }>("/api/rooms", { method: "POST" })).code;
  },
  async roomExists(code: string): Promise<boolean> {
    try {
      await call(`/api/rooms/${encodeURIComponent(code)}`);
      return true;
    } catch {
      return false;
    }
  },
  call,
};
